var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpeakerOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.969 6.52875C33.969 5.12767 35.1363 4 36.5657 4C37.9952 4 39.1625 5.12767 39.1625 6.52875C39.1625 7.93054 37.9952 9.0575 36.5657 9.0575C35.1363 9.0575 33.969 7.93054 33.969 6.52875ZM33 13.3479C33 11.4262 34.6008 9.87633 36.5657 9.87633C38.5307 9.87633 40.1315 11.4255 40.1315 13.3465V13.5207H33V13.3479Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9165 16.1042V26.8959C2.9165 27.5402 3.43884 28.0626 4.08317 28.0626H11.6665L19.9489 35.1618C20.7057 35.8105 21.8748 35.2727 21.8748 34.276V8.13382C21.8748 7.11513 20.6608 6.58572 19.9143 7.27889L11.6665 14.9376H4.08317C3.43884 14.9376 2.9165 15.4599 2.9165 16.1042ZM29.226 12.8283C28.8665 12.3429 28.1815 12.2409 27.6961 12.6004C27.2107 12.9599 27.1087 13.6449 27.4682 14.1303C28.994 16.1903 29.8959 18.7383 29.8959 21.5001C29.8959 24.262 28.994 26.81 27.4682 28.87C27.1087 29.3554 27.2107 30.0404 27.6961 30.3999C28.1815 30.7594 28.8665 30.6574 29.226 30.172C31.0213 27.7481 32.0834 24.7466 32.0834 21.5001C32.0834 18.2537 31.0213 15.2522 29.226 12.8283ZM26.4827 16.6465C26.1952 16.1153 25.5314 15.9178 25.0002 16.2054C24.469 16.493 24.2715 17.1567 24.559 17.6879C25.1723 18.8207 25.5209 20.1181 25.5209 21.5001C25.5209 22.8822 25.1723 24.1795 24.559 25.3123C24.2715 25.8435 24.469 26.5073 25.0002 26.7949C25.5314 27.0824 26.1952 26.8849 26.4827 26.3537C27.2648 24.909 27.7084 23.2548 27.7084 21.5001C27.7084 19.7455 27.2648 18.0912 26.4827 16.6465Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeakerOne);
export default __webpack_public_path__ + "static/media/icon_speaker_one.4445f88f44fd7af25caf2ad12db2f10a.svg";
export { ForwardRef as ReactComponent };